const NoResultsAdvice = ({ message }) => {
  return <p style={{ fontSize: "1.4em" }}>{message}</p>;
};

export { NoResultsAdvice };
